import MessageOutlineIcon from '@eduzz/houston-icons/MessageOutline';
import Topbar from '@eduzz/ui-layout/Topbar';
import Badge from '@material-ui/core/Badge';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import React, { Fragment, memo, useCallback, useMemo, useState } from 'react';
import { useObservable } from 'react-use-observable';
import chatService from 'v2/services/chat';

import MessagesList from './MessagesList';

const useStyles = makeStyles(() => ({
  badge: {
    top: 5,
    rigth: -4,
  },
  iconButton: {
    color: '#ffffff',
  },
}));

const ChatMessages = memo(() => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isFirstOpen, setIsFirstOpen] = useState(true);

  const [unreadMessagesCount, unreadMessagesCountError] = useObservable(() => chatService.getChatUnreadCount(), []);

  const isLoadingCount = unreadMessagesCount === null && unreadMessagesCountError === undefined;

  const handleClose = useCallback(() => {
    setIsFirstOpen(false);
    setAnchorEl(null);
  }, []);

  const handleClick = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const isOpen = useMemo(() => Boolean(anchorEl), [anchorEl]);

  if (isLoadingCount) {
    return <CircularProgress size={19} style={{ color: 'currentColor' }} />;
  }

  return (
    <Fragment>
      <Tooltip title='Mensagens' placement='bottom'>
        <span>
          <Topbar.Action
            id='topbar-action-chat-messages'
            aria-label='mostrar mensagens'
            onClick={handleClick}
            icon={
              <Badge
                showZero={false}
                classes={{ badge: classes.badge }}
                badgeContent={unreadMessagesCount > 99 ? '99+' : unreadMessagesCount}
                color='error'
              >
                <MessageOutlineIcon color='currentColor' size={24} />
              </Badge>
            }
          />
        </span>
      </Tooltip>

      <MessagesList isFirstOpen={isFirstOpen} unreadMessagesCount={unreadMessagesCount} anchorEl={anchorEl} isOpen={isOpen} onClose={handleClose} />
    </Fragment>
  );
});

export default ChatMessages;
